// extracted by mini-css-extract-plugin
export default {"stockNegativePrice":"NewStockComponent_stockNegativePrice__XtZ61","stockPositivePrice":"NewStockComponent_stockPositivePrice__XOGOr","wrapper":"NewStockComponent_wrapper__dhAyv"};